<template>
  <!-- 通过key实现tab切换实现组件更新，否则就要实现各种tab下的数据切换 -->
  <fault-item
    :key="tabIndex"
    :type="tabIndex"
    @tab="onTab"
  ></fault-item>
</template>

<script>
/** 故障列表 */
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import faultItem from './children/fault_item.vue';

export default {
  name: 'faultManage',
  mixins: [tableFilterValueMixins],
  components: {
    faultItem
  },
  props: {
  },
  data() {
    /*
    上方 Tab，组织设备（本组织及本组织名下所有服务公司工单，默认选中），我的设备
下方 Tab，未解除（默认），已解除
    */
    return {
      // 1 - 组织设备  2 - 我的设备
      tabIndex: '1',
      // 1 - 未解除  2 - 已解除
      pageType: 1,

    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    onTab(value) {
      this.tabIndex = value;
    },
    onPageTypeChange(value) {
      this.pageType = value;
    },
  },
  created() {
  },
  mounted() {
  },
};
</script>

<style>
</style>
